import React, { FC } from 'react'

const Step1ModalDocumentPreview: FC<{ documentsPreviewUrl: string[] }> = (
  props
) => {
  const { documentsPreviewUrl } = props

  if (!documentsPreviewUrl.length) {
    return null
  }

  return (
    <div>
      {documentsPreviewUrl.map((value, index) => {
        return (
          <div key={value}>
            <p className="textRight mb15">
              Visualisation de la pièce n° {index + 1}/
              {documentsPreviewUrl.length}
            </p>
            <iframe
              src={`/pdfjs/web/viewer.html?file=${value}`}
              className="pdfIframe mb35 h23"
              id={value}
              title="PDF"
              data-testid="certificate"
            />
          </div>
        )
      })}
    </div>
  )
}

export default Step1ModalDocumentPreview
